<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-layout justify-center align-center wrap>
      <v-flex xs12>
        <div shrink>
          <v-expand-transition>
            <v-layout row wrap v-show="!report">
              <v-flex xs12 md2 lg2 style="height: min-content">
                <SelectCreditors
                  :selected="selectedCreditors"
                  @selectedCreditors="selectedCreditors = $event"
                ></SelectCreditors>
              </v-flex>
              <v-flex xs12 sm6 md4 lg2 style="height: min-content">
                <v-select
                  v-model="selectedPuplic"
                  @change="getDataApi()"
                  success
                  clearable
                  :items="publicStrategy"
                  multiple
                  :selected="selectedPuplic == 0 ? undefined : selectedPuplic"
                  label="Público"
                  flat
                  item-text="name"
                  item-value="value"
                  box
                  class="text-details-none"
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0" style="padding-right: 5px">{{
                      item.name
                    }}</span>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ selectedPuplic.length - 1 }} outros)</span
                    >
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md4 lg2>
                <v-select
                  v-model="selectedApproachTypes"
                  @change="getDataApi()"
                  success
                  clearable
                  :items="approachesTypes"
                  multiple
                  flat
                  box
                  class="text-details-none"
                  label="Tipo de abordagem"
                >
                  <template v-slot:selection="{ item, index }">
                    <!-- <span style="padding-right: 5px;" v-if="index === 0">{{ item.name }}</span> -->  
                    <span v-if="index == 0">{{ index === 0 ? item : ", " + item }}</span>
                    <span
                      v-if="index === 1"
                      style="padding-left: 5px"
                      class="grey--text caption"
                      >(+{{
                        selectedApproachTypes.length -
                        1 +
                        (selectedApproachTypes.length == 2 ? " outro)" : " outros)")
                      }}</span
                    >
                  </template>
                </v-select>
              </v-flex>

              <v-flex xs12 sm6 md3 lg2>
                <v-select
                  box
                  flat
                  success
                  multiple
                  clearable
                  hide-details
                  label="Gateway"
                  item-value="id"
                  item-text="name"
                  :items="gateways"
                  @change="getDataApi()"
                  v-model="selectedGateway"
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0" style="padding-right: 5px">{{
                      item.name
                    }}</span>
                    <span
                      v-if="index === 1"
                      style="padding-left: 5px"
                      class="grey--text caption"
                      >(+{{
                        selectedGateway.length -
                        1 +
                        (selectedGateway.length == 2 ? " outro)" : " outros)")
                      }}</span
                    >
                  </template>
                </v-select>
              </v-flex>
              <!-- <v-flex xs12 sm6 md4 lg4 style="height: min-content">
                <v-combobox
                  clearable
                  v-model="strategyCombobox"
                  single-line
                  success
                  :items="strategies"
                  autocomplete
                  placeholder="Selecionar estratégias"
                  item-text="label"
                  item-value="id"
                  multiple
                  @focus="getStrategies()"
                  @change="getDataApi()"
                  box
                  class="text-details-none"
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index <= 1 && item.approach">
                      <span :class="`tag-approach-type small ${item.approach.type}`">{{
                        item.approach.type
                      }}</span>
                      <span style="padding-right: 5px"
                        >{{ item.label.split(" - ")[0] }},</span
                      >
                    </span>
                    <span v-if="index === 2 && item.approach" class="grey--text caption"
                      >(+{{ strategyCombobox.length - 2 }} outras)</span
                    >
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <span>
                        <v-checkbox v-model="data.item.selected"></v-checkbox>
                      </span>
                      <span
                        @click="data.item.selected = !data.item.selected"
                        v-if="data.item.approach"
                      >
                        <span
                          :class="`tag-approach-type small ${data.item.approach.type}`"
                          >{{ data.item.approach.type }}</span
                        >
                      </span>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="data.item.label"></v-list-tile-title>
                      </v-list-tile-content>
                    </template>
                  </template>
                </v-combobox>
              </v-flex> -->
              <v-flex xs12 sm6 md3 lg2 style="height: min-content" id="date-picker-range">
                <v-md-date-range-picker
                  style="margin: 0px !important"
                  :opens="'right'"
                  @change="handleChange"
                  :presets="presets"
                  :start-date="this.range.start"
                  :end-date="this.range.end"
                ></v-md-date-range-picker>
              </v-flex>
              <v-flex xs12 sm6 md2 lg2>
                <v-btn
                  block
                  large
                  @click="getDataApi"
                  :loading="loadingStrategyTable"
                  :disabled="loadingStrategyTable"
                  >Atualizar</v-btn
                >
              </v-flex>
              <!-- <v-flex xs12 md1>
                  <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                          <span v-on="on">                                    
                              <v-switch
                                  label="Atualizar"
                                  style="justify-content: center;"
                                  hide-details
                                  v-model="autoUpdate"
                              ></v-switch>
                          </span>
                      </template>
                      <span>Atualizar dados automaticamente</span>
                  </v-tooltip>
              </v-flex>-->
            </v-layout>
          </v-expand-transition>
          <v-expand-transition>
            <v-layout row wrap v-show="report">
              <v-flex xs12 style="display: flex; align-items: center">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      value="notify"
                      color="accent"
                      style="border-radius: 5px"
                      v-on="on"
                      >Extrair relatório</v-btn
                    >
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in itemsBtn"
                      :key="index"
                      @click="item.func"
                    >
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <span class="font-weight-medium subheading" v-if="selected.length"
                  >{{ selected.length }}
                  {{ selected.length == 1 ? "Selecionado" : "Selecionados" }}</span
                >
                <v-btn
                  flat
                  icon
                  large
                  class="my-0 py-0"
                  color="accent"
                  @click="selected = []"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-expand-transition>
        </div>
      </v-flex>
      <v-flex xs12 pt-0>
        <v-data-table
          locale="pt-br"
          rows-per-page-text="Mostrar"
          no-data-text="Nenhum disparo encontrado"
          style="border: 1px solid rgba(0, 0, 0, 0.12); border-radius: 4px"
          :items="rowData"
          :total-items="totalRows"
          :headers="headersStrategyTable"
          :pagination.sync="paginationStrategyTable"
          :rows-per-page-items="paginationStrategyTable.rowsPerPageItems"
        >
          <template v-slot:items="row">
            <tr style="cursor: pointer">
              <td @click="row.expanded = !row.expanded">
                {{ row.item.firings[0].creditor_name }}
              </td>
              <td
                @click="row.expanded = !row.expanded"
                :style="
                  row.item.public ? `color:${strategyPublic[row.item.public].color}` : ''
                "
              >
                <b>{{
                  row.item.public
                    ? strategyPublic[row.item.public].name.toUpperCase()
                    : ""
                }}</b>
              </td>
              <td @click="row.expanded = !row.expanded">
                <a @click="goToApproach(row.item)">
                  <span :class="`tag-approach-type small ${row.item.approach_type}`">{{
                    row.item.approach_type
                  }}</span>
                </a>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <a
                      v-on="on"
                      style="display: inline-grid; align-items: center"
                      @click="goToStrategy(row.item)"
                    >
                      <p class="mb-0 truncate">{{ row.item.firing_name }}</p>
                    </a>
                  </template>
                  <span>{{ row.item.firing_name }}</span>
                </v-tooltip>
                <!-- {{ row.item.name.firing_name > 60 ? row.item.firing_name.substr(0,60)+' ...' : row.item.firing_name }} -->
              </td>

              <td @click="row.expanded = !row.expanded">
                <div class="text-xs-center">
                  <v-chip small>
                    <b>{{ row.item.firings.length | numeral("0,0") }}</b>
                  </v-chip>
                </div>
              </td>
              <td @click="row.expanded = !row.expanded">
                <div class="text-xs-center">
                  <v-chip small>
                    <b>{{ totalNotifications(row.item.firings) | numeral("0,0") }}</b>
                  </v-chip>
                </div>
              </td>
              <td class="text-xs-center" @click="row.expanded = !row.expanded">
                <v-tooltip top v-if="checkNotificationToday(row.item.last_notified_at)">
                  <template v-slot:activator="{ on }">
                    <v-icon color="green" v-on="on">call_made</v-icon>
                  </template>
                  <span>Disparado</span>
                </v-tooltip>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on }">
                    <v-icon color="grey" v-on="on">remove</v-icon>
                  </template>
                  <span>Não disparado</span>
                </v-tooltip>
              </td>
              <td @click="row.expanded = !row.expanded">
                <div class="text-xs-center">
                  <v-chip small>
                    <b>{{ row.item.last_notified_at | formatDateTime }}</b>
                  </v-chip>
                </div>
              </td>
              <td class="text-xs-center" @click="row.expanded = !row.expanded">
                <div style="height: 30px; width: 105px; display: flex; margin: auto">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        style="border-radius: 4px; height: 20px; margin: 4px; width: 20px"
                        :class="
                          setColor2(
                            row.item.accessed_rate,
                            row.item.indicator_good_accessed,
                            row.item.indicator_bad_accessed
                          )
                        "
                      ></div>
                    </template>
                    <span>Interesse</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        style="border-radius: 4px; height: 20px; margin: 4px; width: 20px"
                        :class="
                          setColor2(
                            row.item.interest_rate,
                            row.item.indicator_good_interest,
                            row.item.indicator_bad_interest
                          )
                        "
                      ></div>
                    </template>
                    <span>Conversão</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        style="border-radius: 4px; height: 20px; margin: 4px; width: 20px"
                        :class="
                          setColor2(
                            row.item.implantation_rate,
                            row.item.indicator_good_implantation,
                            row.item.indicator_bad_implantation
                          )
                        "
                      ></div>
                    </template>
                    <span>Taxa de implantação</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        style="border-radius: 4px; height: 20px; margin: 4px; width: 20px"
                        :class="
                          setColor3(
                            row.item.cpp,
                            row.item.indicator_good_cpp,
                            row.item.indicator_bad_cpp
                          )
                        "
                      ></div>
                    </template>
                    <span>CPP</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        style="border-radius: 4px; height: 20px; margin: 4px; width: 20px"
                        :class="
                          setColor3(
                            row.item.ppp,
                            row.item.indicator_good_ppp,
                            row.item.indicator_bad_ppp
                          )
                        "
                      ></div>
                    </template>
                    <span>PPP</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        style="border-radius: 4px; height: 20px; margin: 4px; width: 20px"
                        :class="
                          setColor3(
                            row.item.cash_cost,
                            row.item.indicator_good_cash_cost,
                            row.item.indicator_bad_cash_cost
                          )
                        "
                      ></div>
                    </template>
                    <span>CC</span>
                  </v-tooltip>
                </div>
              </td>

            </tr>
          </template>
          <template v-slot:expand="row">
            <div style="display: flex; padding-top: 5px">
              <v-list dense style="width: 130px; margin-top: 50px">
                <v-list-tile
                  v-for="item in listIndex"
                  :key="item.value"
                  class="list-no-pl"
                >
                  <v-list-tile-content>
                    <!-- Title -->
                    {{ item.value }}
                    <span style="font-size: 11px" v-if="item.index == 'custo'">
                      <!-- Custo -->
                      R$ {{ row.item.notifications_cost | numeral("0,0[.]00") }}
                    </span>
                    <span
                      style="font-size: 11px"
                      v-else-if="item.index == 'interest_rate'"
                      :class="
                        setColor2(
                          row.item.interest_rate,
                          row.item.indicator_good_interest,
                          row.item.indicator_bad_interest,
                          true
                        )
                      "
                    >
                      {{ row.item.interest_rate | numeral("0.[00]%") }}
                      ({{ row.item.proposals_confirmed | numeral("0,0") }})
                    </span>
                    <span
                      style="font-size: 11px"
                      v-else-if="item.index == 'implantation_rate'"
                      :class="
                        setColor2(
                          row.item.implantation_rate,
                          row.item.indicator_good_implantation,
                          row.item.indicator_bad_implantation,
                          true
                        )
                      "
                    >
                      {{ row.item.implantation_rate | numeral("0.[00]%") }}
                      ({{ row.item.proposals_agreed | numeral("0,0") }})
                    </span>
                    <span
                      style="font-size: 11px"
                      v-else-if="item.index == 'cpp'"
                      :class="
                        setColor3(
                          row.item.cpp,
                          row.item.indicator_good_cpp,
                          row.item.indicator_bad_cpp,
                          true
                        )
                      "
                    >
                      <!-- CPP -->
                      <small style="font-size: 11px" v-if="row.item.cpp > 0"
                        >R$ {{ row.item.cpp | numeral("0,0[.]00") }}
                      </small>
                      <small v-else>-</small>
                    </span>

                    <span
                      style="font-size: 11px"
                      v-else-if="item.index == 'ppp'"
                      :class="
                        setColor3(
                          row.item.ppp,
                          row.item.indicator_good_ppp,
                          row.item.indicator_bad_ppp,
                          true
                        )
                      "
                    >
                      <!-- PPP -->
                      <small style="font-size: 11px" v-if="row.item.proposals_agreed > 0"
                        >R$ {{ row.item.avg_potential/row.item.proposals_agreed | numeral("0,0[.]00") }}
                      </small>
                      <small v-else>-</small>
                    </span>
                    <span
                      style="font-size: 11px"
                      v-else-if="item.index == 'cash_cost'"
                      :class="
                        setColor3(
                          row.item.cash_cost,
                          row.item.indicator_good_cash_cost,
                          row.item.indicator_bad_cash_cost,
                          true
                        )
                      "
                    >
                      <!-- CC -->
                      <small style="font-size: 11px" v-if="row.item.notifications_cost > 0"
                        > {{ row.item.down_payment_potential/row.item.notifications_cost | numeral("0,0[.]00") }}
                      </small>
                      <small v-else>-</small>
                    </span>
                    <span style="font-size: 11px" v-else-if="item.index == 'cpl'">
                      <small
                        style="font-size: 10px !important;"
                      >
                        <!-- CPL -->{{ row.item.localized }} (R$
                        {{ row.item.cpl | numeral("0,0[.]00") }})
                      </small>
                    </span>

                    <span
                      v-else-if="item.index == 'accessed'"
                      style="font-size: 11px"
                      :class="
                        setColor2(
                          row.item.accessed_rate,
                          row.item.indicator_good_accessed,
                          row.item.indicator_bad_accessed,
                          true
                        )
                      "
                    >
                      {{ row.item.accessed_rate | numeral("0.[00]%") }}
                      ({{ row.item.accessed | numeral("0,0") }})
                    </span>

                    <span
                      v-else-if="item.index == 'localized'"
                      style="font-size: 11px"
                      :class="
                        setColor2(
                          row.item.localized_rate,
                          row.item.indicator_good_localized,
                          row.item.indicator_bad_localized,
                          true
                        )
                      "
                    >
                      {{ row.item.localized_rate | numeral("0.[00]%") }}
                      ({{ row.item.localized | numeral("0,0") }})
                    </span>

                    <span
                      v-else-if="item.index == 'deal_viewed'"
                      style="font-size: 11px"
                      :class="
                        setColor2(
                          row.item.deal_viewed_rate,
                          row.item.indicator_good_deal_viewed,
                          row.item.indicator_bad_deal_viewed,
                          true
                        )
                      "
                    >
                      {{ row.item.deal_viewed_rate | numeral("0.[00]%") }}
                      ({{ row.item.deal_viewed | numeral("0,0") }})
                    </span>
                    <!-- :class="item.index != 'notifications' ? setColor(item.index, row.item, true) : ''" -->

                    <span
                      v-else-if="item.index == 'notifications_delivered'"
                      style="font-size: 11px"
                    >
                      <!-- Percentage -->
                      {{ row.item.delivered_rate | numeral("0.[00]%") }}
                      <!-- Total -->
                      ({{ row.item[item.index] | numeral("0,0") }})
                    </span>

                    <span v-else style="font-size: 11px">
                      <!-- Total -->
                      {{ calcTotal(row.item, item.index) }}
                      <!-- Percentage -->
                      {{
                        item.index == "notifications"
                          ? ""
                          : "(" +
                            calcPercent(
                              row.item.firings,
                              calcTotal(row.item, item.index)
                            ) +
                            "%)"
                      }}
                    </span>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-card flat style="width: calc(100% - 145px)">
                <v-container fluid grid-list-md style="padding: 0">
                  <v-data-iterator
                    :items="row.item.firings"
                    :rows-per-page-items="verifyBreakpoint()"
                    content-tag="v-layout"
                    v-model="selected"
                    row
                    wrap
                  >
                    <template v-slot:item="props">
                      <v-flex xs12 sm6 md4 lg2>
                        <v-hover>
                          <v-card
                            :style="
                              'border: 1px solid rgba(0,0,0,.12);cursor: pointer;' +
                              (props.selected ? 'background: #f5f5f5' : '')
                            "
                            slot-scope="{ hover }"
                            :class="`elevation-${hover ? 3 : 0}`"
                          >
                            <v-card-title
                              @click="props.selected = !props.selected"
                              class="pa-1 pl-2"
                            >
                              <div
                                style="
                                  width: 100%;
                                  display: flex;
                                  align-items: center;
                                  justify-content: space-between;
                                "
                              >
                                <h4>
                                  <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                      <div v-on="on" class="d-flex">
                                        <div>{{ nameUser(props.item) }}</div>
                                        <span class="pl-1">{{
                                          props.item.created_at | formatDateAgo
                                        }}</span>
                                      </div>
                                    </template>
                                    <span
                                      >Gerado em
                                      {{ props.item.created_at | formatDateTime }}</span
                                    >
                                  </v-tooltip>
                                </h4>
                                <div style="margin-left: auto">
                                  <v-checkbox
                                    :input-value="props.selected"
                                    v-model="props.selected"
                                    primary
                                    hide-details
                                    @click.prevent
                                  ></v-checkbox>
                                </div>
                              </div>
                              <samp style="margin-top: -5px">{{
                                props.item.gateway_id | gatewayName(gateways)
                              }}</samp>
                            </v-card-title>
                            <v-divider class="ma-0"></v-divider>
                            <div @click="openDetailModal(props.item)">
                              <v-list dense> <!-- Inicio -->
                                <v-list-tile> <!-- notification -->
                                  <v-list-tile-content
                                    class="text-xs-left"
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                  >
                                    <b style="font-size: 16px; padding-right: 5px">{{
                                      props.item.notifications | numeral("0,0")
                                    }}</b>
                                  </v-list-tile-content>
                                </v-list-tile> <!-- notification -->

                                <v-list-tile> <!-- notification delivered -->
                                  <v-list-tile-content
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                  >
                                    <b style="font-size: 14px">{{
                                      props.item.delivered_rate | numeral("0.[00]%")
                                    }}</b>
                                    <b style="font-size: 14px; padding-right: 5px"> ({{
                                      props.item.notifications_delivered | numeral("0,0")
                                    }})</b>
                                    
                                  </v-list-tile-content>
                                </v-list-tile> <!-- notification delivered -->

                                <v-list-tile> <!-- interesse -->
                                  <v-list-tile-content
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                    :class="
                                      setColor2(
                                        props.item.accessed_rate,
                                        row.item.indicator_good_accessed,
                                        row.item.indicator_bad_accessed,
                                        true
                                      )
                                    "
                                  >
                                    <b style="font-size: 14px">{{
                                      props.item.accessed_rate | numeral("0.[00]%")
                                    }}</b>
                                    <span style="font-size: 12px; padding-right: 5px"
                                      >({{ props.item.accessed | numeral("0,0") }})</span
                                    >
                                  </v-list-tile-content>
                                </v-list-tile> <!-- interesse -->
                                <v-list-tile> <!-- Localizados -->
                                  <v-list-tile-content
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                  >
                                    <b style="font-size: 14px">{{
                                      props.item.localized_rate | numeral("0.[00]%")
                                    }}</b>
                                    <b style="font-size: 14px; padding-right: 5px"> ({{
                                      props.item.localized | numeral("0,0")
                                    }})</b>
                                    
                                  </v-list-tile-content>
                                </v-list-tile> <!-- Localizados -->
                                <v-list-tile> <!-- Deal Visualizado -->
                                  <v-list-tile-content
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                  >
                                    <b style="font-size: 14px">{{ 
                                      props.item.deal_viewed_rate | numeral("0.[00]%") 
                                    }}</b>
                                    <b style="font-size: 14px; padding-right: 5px"> ({{ 
                                      props.item.deal_viewed | numeral("0,0") 
                                    }})</b>
                                    
                                  </v-list-tile-content>
                                </v-list-tile> <!-- Deal Visualizado -->
                                <v-list-tile> <!-- conversao -->
                                  <v-list-tile-content
                                    class="text-xs-left"
                                    :class="
                                      setColor2(
                                        props.item.interest_rate,
                                        row.item.indicator_good_interest,
                                        row.item.indicator_bad_interest,
                                        true
                                      )
                                    "
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                  >
                                    <b style="font-size: 14px; padding-right: 5px">{{
                                      props.item.interest_rate | numeral("0.[00]%")
                                    }}</b>

                                    <span style="font-size: 12px"
                                      >({{
                                        props.item.proposals_confirmed | numeral("0,0")
                                      }})</span
                                    >
                                  </v-list-tile-content>
                                </v-list-tile> <!-- conversao -->
                                <v-list-tile> <!-- implantacao  -->
                                  <v-list-tile-content
                                    class="text-xs-left"
                                    :class="
                                      setColor2(
                                        props.item.implantation_rate,
                                        row.item.indicator_good_implantation,
                                        row.item.indicator_bad_implantation,
                                        true
                                      )
                                    "
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                  >
                                    <b style="font-size: 14px; padding-right: 5px">{{
                                      props.item.implantation_rate | numeral("0.[00]%")
                                    }}</b>
                                    <span style="font-size: 12px"
                                      >({{
                                        props.item.proposals_agreed | numeral("0,0")
                                      }})</span
                                    >
                                  </v-list-tile-content>
                                </v-list-tile> <!-- implantacao  -->
                                <v-list-tile> <!-- custo -->
                                  <v-list-tile-content
                                    class="text-xs-left"
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                  >
                                    <b style="font-size: 14px; padding-right: 5px"
                                      >R$
                                      {{
                                        props.item.notification_cost | numeral("0,0[.]00")
                                      }}</b
                                    >
                                  </v-list-tile-content>
                                </v-list-tile> <!-- custo -->
                                <!--  -->
                                <v-list-tile> <!-- CPP  -->
                                  <v-list-tile-content
                                    class="text-xs-left"
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                    :class="
                                      setColor3(
                                        props.item.cpp,
                                        row.item.indicator_good_cpp,
                                        row.item.indicator_bad_cpp,
                                        true
                                      )
                                    "
                                  >
                                    <b
                                      v-if="props.item.cpp > 0"
                                      style="font-size: 14px; padding-right: 5px"
                                      >R$ {{ props.item.cpp | numeral("0,0[.]00") }}</b
                                    >
                                    <b v-else style="font-size: 14px; padding-right: 5px"
                                      >-</b
                                    >
                                  </v-list-tile-content>
                                </v-list-tile> <!-- CPP  -->

                                <v-list-tile> <!-- CPL  -->
                                  <v-list-tile-content
                                    class="text-xs-left"
                                      style="
                                        display: inline-block;
                                        vertical-align: middle;
                                        line-height: 40px;
                                      "
                                      :class="
                                        setColor3(
                                          props.item.cpl,
                                          row.item.indicator_good_cpl,
                                          row.item.indicator_bad_cpl,
                                          true
                                        )
                                      "
                                    >
                                      <b
                                        v-if="props.item.cpl > 0"
                                        style="font-size: 14px; padding-right: 5px"
                                        >R$ {{ props.item.cpl | numeral("0,0[.]00") }}</b
                                      >
                                      <b v-else style="font-size: 14px; padding-right: 5px"
                                        >-</b
                                      >
                                  </v-list-tile-content>
                                </v-list-tile> <!-- CPL  -->

                                <v-list-tile> <!-- CC -->
                                  <v-list-tile-content
                                    class="text-xs-left"
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                    :class="
                                      setColor3(
                                        props.item.cash_cost,
                                        row.item.indicator_good_cash_cost,
                                        row.item.indicator_bad_cash_cost,
                                        true
                                      )
                                    "
                                  >
                                    <b
                                      v-if="props.item.notification_cost > 0"
                                      style="font-size: 14px; padding-right: 5px"
                                      > {{ props.item.down_payment_potential/props.item.notification_cost | numeral("0,0[.]00") }}</b
                                    >
                                    <b v-else style="font-size: 14px; padding-right: 5px"
                                      >-</b
                                    >
                                  </v-list-tile-content>
                                </v-list-tile> <!-- CC -->
                                <v-list-tile> <!-- PPP -->
                                  <v-list-tile-content
                                    class="text-xs-left"
                                    style="
                                      display: inline-block;
                                      vertical-align: middle;
                                      line-height: 40px;
                                    "
                                    :class="
                                      setColor3(
                                        props.item.ppp,
                                        row.item.indicator_good_ppp,
                                        row.item.indicator_bad_ppp,
                                        true
                                      )
                                    "
                                  >
                                    <b
                                      v-if="props.item.proposals_agreed > 0"
                                      style="font-size: 14px; padding-right: 5px"
                                      >R$ {{ props.item.avg_potential/props.item.proposals_agreed | numeral("0,0[.]00") }}</b
                                    >
                                    <b v-else style="font-size: 14px; padding-right: 5px"
                                      >-</b
                                    >
                                  </v-list-tile-content>
                                </v-list-tile> <!-- PPP -->

                              </v-list> <!-- FIM -->
                            </div>
                          </v-card>
                        </v-hover>
                      </v-flex>
                    </template>
                  </v-data-iterator>
                </v-container>
              </v-card>
            </div>
          </template>
          <template v-slot:no-data>
            <v-container
              fluid
              fill-height
              style="background-color: rgba(255, 255, 255, 0.5)"
            >
              <v-layout justify-center align-center>
                <v-progress-circular
                  v-if="loadingStrategyTable"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <strong v-else class="py-2" style="font-color: red; font-size: 14px"
                  >Nenhum disparo encontrado</strong
                >
              </v-layout>
            </v-container>
          </template>
        </v-data-table>
      </v-flex>
      <NotificationMessages ref="notification"></NotificationMessages>
    </v-layout>
  </v-container>
</template>

<script>
import Cookies from 'js-cookie'
import enviroment from '@/enviroment';
import moment from "moment";
import store from "@/store";
import checkMobile from "@/mixins/checkMobile";
import { EventBus } from "@/services/event-bus";
import gatewaysService from "@/services/gateways";
import strategyService from "@/services/strategy";
import strategyPublic from "@/utils/strategy-public";
import reportingService from "@/services/reporting/reporting";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import strategyNotificationService from "@/services/notification-history";
import NotificationMessages from "@/views/notification/components/NotificationMessages";

export default {
  filters: {
    gatewayName(id, gateways = []) {
      if (!id) return "";
      let gateway = gateways.find((g) => g.id == id);
      return gateway ? gateway.name : "";
    },
  },
  data() {
    return {
      totalRows: 0,
      trava: true,
      report: false,
      loadingStrategyTable: true,
      // interval: null,
      firing_id: null,
      rowData: [],
      // pulling: [],
      gateways: [],
      selected: [],
      creditors: [],
      strategies: [],
      allStrategies: [],
      publicStrategy: [],
      selectedPuplic: [],
      selectedGateway: [],
      strategyCombobox: [],
      selectedCreditors: [],
      selectedApproachTypes: [],
      approachesTypes: ["SMS", "PUSH"],
      autoUpdate: true,
      itemsBtn: [{ title: "Analítico de disparo", func: this.generateReport }],
      headersStrategyTable: [
        {
          text: "Credor",
          sortable: false,
          value: "creditor_name",
          width: "10%",
        },
        { text: "Público", value: "public", width: "10%" },
        { text: "Estratégia", sortable: false, value: "name" },
        {
          text: "Disparos",
          value: "value",
          sortable: false,
          width: "2%",
        },
        {
          text: "Notificações",
          value: "notifications",
          sortable: false,
          width: "5%",
        },      
        {
          text: "Status",
          value: "last_notified_at",
          align: "center",
          width: "5%",
        },
        { text: "Último Envio",
          align: "center",
          value: "last_notified_at",
          width: "7%"
        },
        {
          text: "Desempenho",
          value: "",
          align: "center",
          sortable: false,
          width: "7%",
        }

      ],
      listIndex: [
        { value: "Notificações:", index: "notifications" },
        { value: "Entregues:", index: "notifications_delivered" },
        { value: "Interesse:", index: "accessed" },
        { value: "Localizados:", index: "localized" },
        { value: "Deal Visualizado:", index: "deal_viewed" },
        { value: "Conversão:", index: "interest_rate" },
        { value: "Implantação:", index: "implantation_rate" },
        { value: "Custo:", index: "custo" },
        { value: "CPP:", index: "cpp" },
        { value: "CPL:", index: "cpl" },
        { value: "CC:", index: "cash_cost" },
        { value: "PPP:", index: "ppp" },
      ],
      presets: [
        {
          label: "Hoje",
          range: this.getRange(0, 0),
        },
        {
          label: "Ontem",
          range: this.getRange(1, 1),
        },
        {
          label: "Últimos 7 dias",
          range: this.getRange(6, 0),
        },
        {
          label: "Últimos 30 dias",
          range: this.getRange(29, 0),
        },
        {
          label: "Este mês",
          range: this.getRange(0, 0, "month"),
        },
        {
          label: "Mês passado",
          range: this.getRange(1, 1, "month"),
        },
      ],
      query: {},
      strategyPublic: [],
      paginationStrategyTable: {
        descending: true,
        page: 1,
        rowsPerPage: 50,
        sortBy: "last_notified_at",
        rowsPerPageItems: [50, 100, 200],
      },
      range: {
        start: moment().subtract(0, "day").format("YYYY-MM-DD"),
        end: moment().subtract(0, "day").format("YYYY-MM-DD"),
      },
    };
  },
  components: {
    NotificationMessages,
    SelectCreditors,
  },
  async created() {
    await this.getGateway();
    // this.getStrategies();

    strategyPublic.strategyPublic.forEach((e, i) => {
      this.strategyPublic[e.value] = strategyPublic.strategyPublic[i];
    });
    this.publicStrategy = strategyPublic.strategyPublic;

    this.query = this.$route.query;
    if (this.query && Object.keys(this.query).length == 0) {
      this.query = store.getters.getManualStrategy;
    }

    if (this.query) {
      if (this.query.creditors) {
        let ids = this.query.creditors.split(",");
        ids.forEach((id) => {
          this.selectedCreditors.push(id);
          // this.creditors.forEach((el) => {
          //     if (id == el.id) this.selectedCreditors.push(el.id);
          // });
        });
      }
      if (this.query.types) {
        this.query.types.split(",").forEach((id) => {
          this.selectedApproachTypes.push(id);
        });
      }

      if (this.query.creditor) {
          this.selectedCreditors.push(this.query.creditor);
      }
      if (length > 1) {
        this.public 
      }
      if (this.query.public) {
        let _public = this.query.public.split(",");
        _public.forEach((p) => {
          this.publicStrategy.forEach((el) => {
            if (p == el.value) this.selectedPuplic.push(el.value);
          });
        });
      }
      if (this.query.approachTypes) {
        let _types = this.query.approachTypes.split(",");
        this.selectedApproachTypes = [];
        _types.forEach((p) => {
          this.approachesTypes.forEach((el) => {
            if (p == el) this.selectedApproachTypes.push(el);
          });
        });
      }
      if (this.query.gateways) {
        let _gateways = this.query.gateways.split(",");
        this.selectedGateway = [];
        _gateways.forEach((p) => {
          this.gateways.forEach((el) => {
            if (parseInt(p) == el.id) this.selectedGateway.push(el.id);
          });
        });
      }
    }

    if (this.query) {
      let page = 0;
      if (this.query.strategies) {
        let ids = this.query.strategies.split(",");
        ids.forEach((id) => {
          this.strategies.forEach((el) => {
            if (id == el.id) this.strategyCombobox.push(el);
          });
        });
      }

      if (this.query.update) {
        if (typeof this.query.update == "string") {
          this.autoUpdate = JSON.parse(this.query.update.toLowerCase());
        } else {
          this.autoUpdate = this.query.update;
        }
      }

      if (this.query.start && this.query.end) {
        this.range.start = this.query.start;
        this.range.end = this.query.end;
      }
      if (this.query.sortBy) this.paginationStrategyTable.sortBy = this.query.sortBy;
      if (this.query.descending)
        this.paginationStrategyTable.descending = this.query.descending;
      else if (this.query.sortBy) this.paginationStrategyTable.descending = false;
      if (this.query.rowsPerPage)
        this.paginationStrategyTable.rowsPerPage = Number(this.query.rowsPerPage);
      if (this.query.page) this.paginationStrategyTable.page = Number(this.query.page);
      if (this.query.descending) {
        if (typeof this.query.descending == "string") {
          this.descending = JSON.parse(this.query.descending.toLowerCase());
        } else {
          this.descending = this.query.descending;
        }
      }
      if (this.query.firing_id) {
        this.firing_id = this.query.firing_id;
        let firing = await strategyNotificationService.get(this.firing_id);
        if (firing) {
          this.openDetailModal(firing);
        }
      }
    }

    await this.getDataApi();
    this.paginationStrategyTable.page = Number(this.query.page);
    // this.setIntervalPulling();
    setTimeout(() => (this.trava = false), 500);
  },
  beforeMount() {
    let vm = this;
    EventBus.$on("notificationHistoryModal", async (dialog, firing_id) => {
      if (dialog) vm.firing_id = firing_id;
      else vm.firing_id = null;

      this.addfilters();
    });
  },
  mixins: [checkMobile],
  watch: {
    paginationStrategyTable: {
      handler() {
        if (!this.trava) {
          this.getDataApi();
        }
      },
      deep: true,
    },
    autoUpdate: {
      handler() {
        this.addfilters();
      },
    },
    selectedCreditors: {
      handler() {
        if (!this.trava) {
          this.getStrategies(true);
          this.getDataApi();
        }
      },
      deep: true,
    },
    selected: {
      async handler() {
        this.report = this.selected.length >= 1 ? true : false;
      },
    },
    strategyCombobox: {
      async handler() {
        this.selectStrategies();
      },
    },
  },
  methods: {
    getDataApi() {
      //isPulling = false
      this.addfilters();

      let creditors = [],
        publics = "",
        strategies = "",
        match = "",
        approachTypes = "",
        gatewaysIds = "",
        filter = {
          order: "",
          limit: "",
          page: "",
        };

      filter.page = this.paginationStrategyTable.page;
      filter.limit =
        this.paginationStrategyTable.rowsPerPage == -1
          ? 9999
          : this.paginationStrategyTable.rowsPerPage;
      if (this.paginationStrategyTable.sortBy)
        filter.order =
          (this.paginationStrategyTable.descending ? "-" : "") +
          this.paginationStrategyTable.sortBy;

      if (this.selectedCreditors.length)
        creditors = this.selectedCreditors.map((id) => id).join(",");
      if (this.selectedPuplic.length)
        publics = this.selectedPuplic.map((sp) => sp).join(",");
      if (this.strategyCombobox.length)
        strategies = this.strategyCombobox.map((str) => str.id).join(",");

      if (this.selectedApproachTypes.length) {
        approachTypes = this.selectedApproachTypes.map((sp) => sp).join(",");
      }
      if (this.selectedGateway.length) {
        gatewaysIds = this.selectedGateway.join(",");
      }

      strategyNotificationService
        .getGroupByStrategy(
          creditors,
          publics,
          strategies,
          approachTypes,
          gatewaysIds,
          this.range,
          filter
        )
        .then((resp) => {
          resp.objects.forEach((item) => item.firings.reverse());
          resp.objects.forEach((item) => {
            item.value =
              (item.firings[0].notifications / item.last_notification_count) * 100;
          });
          this.totalRows = resp.num_results;
          // if (isPulling) {
          //     this.pulling = resp.objects;
          // } else {
          this.rowData = resp.objects;
          // }
        })
        .catch((error) => {
          console.error(error);
          this.$store.commit("showSnackbar", "Houve um erro ao buscar os dados");
        })
        .finally(() => {
          this.loadingStrategyTable = false;
        });
    },
    addfilters() {
      this.query = {};
      this.query.update = this.autoUpdate;
      if (this.paginationStrategyTable.sortBy)
        this.query.sortBy = this.paginationStrategyTable.sortBy;
      else this.query.sortBy = 0;
      if (this.paginationStrategyTable.descending)
        this.query.descending = this.paginationStrategyTable.descending;
      if (this.range.start && this.range.end) {
        this.query.start = this.range.start;
        this.query.end = this.range.end;
      }
      if (this.strategyCombobox.length) {
        this.query.strategies = this.strategyCombobox.map((str) => str.id).join(",");
      }
      if (this.selectedCreditors.length) {
        this.query.creditors = this.selectedCreditors.map((str) => str).join(",");
      }
      if (this.selectedPuplic.length) {
        this.query.public = this.selectedPuplic.map((sp) => sp).join(",");
      }
      if (this.selectedApproachTypes.length) {
        this.query.approachTypes = this.selectedApproachTypes.map((sp) => sp).join(",");
      }
      if (this.selectedGateway.length) {
        this.query.gateways = this.selectedGateway.map((id) => id).join(",");
      }
      if (this.firing_id) {
        this.query.firing_id = this.firing_id;
      }
      this.query.rowsPerPage = this.paginationStrategyTable.rowsPerPage;
      this.query.page = this.paginationStrategyTable.page;
      this.$store.commit("setManualStrategy", this.query);
      if (this.$route.path == "/notifications-history") {
        this.$router.replace({
          name: "Histórico de disparos",
          query: this.query,
        });
      }
    },
    verifyBreakpoint() {
      let items = [6];
      if (this.$vuetify.breakpoint.md) {
        items = [3];
      } else if (this.$vuetify.breakpoint.sm) {
        items = [2];
      } else if (this.$vuetify.breakpoint.xs) {
        items = [1];
      }
      return items;
    },
    async getStrategies(filter = false) {
      let vm = this;

      if (filter) {
        if (this.selectedCreditors.length) {
          vm.strategies = vm.allStrategies.filter((str) =>
            vm.selectedCreditors.includes(str.creditor_id)
          );
          vm.strategyCombobox = vm.strategyCombobox.filter((str) =>
            vm.selectedCreditors.includes(str.creditor_id)
          );
        } else {
          vm.strategies = vm.allStrategies;
        }

        this.sortStrategiasByPublic();
        this.selectStrategies();
      } else {
        if (this.calcDiffDate()) {
          await strategyService
            .listAll(false, false, false, true, false, true)
            .then(async (res) => {
              vm.allStrategies = res.objects;
              Cookies.set("allStrategies",vm.allStrategies, {
                  domain: enviroment.cookiesDomain,
                  path: '/'
              })
              let d = new Date();
              Cookies.set("dateStrategies", d.getTime(), {
                  domain: enviroment.cookiesDomain,
                  path: '/'
              })
              vm.getStrategies(true);
            })
            .catch((err) => {
              console.error(err);
              vm.$store.commit("showSnackbar", "Houve um erro ao buscar estratégias");
            });
        } else {
          vm.allStrategies = Cookies.get("allStrategies")
          vm.getStrategies(true);
        }
      }
    },
    async getGateway() {
      await gatewaysService.gateways().then((resp) => {
        resp.objects.forEach((item) => {
          this.gateways.push({
            id: item.id,
            name: item.name,
          });
        });
      });
    },
    sortStrategiasByPublic() {
      let vm = this;
      let strategies = [];
      vm.strategies.forEach((el) => {
        el.label = `#${el.id} - ${el.name}`;
      });
      let useDivider = false;
      vm.publicStrategy.forEach((i) => {
        let filtered = [];
        filtered = vm.strategies.filter((e) => e.public === i.value);
        if (filtered.length) {
          filtered.unshift({
            header: i.name,
          });
          if (useDivider)
            filtered.unshift({
              divider: true,
            });
          strategies = strategies.concat(filtered);
          useDivider = true;
        }
      });
      vm.strategies = strategies;
    },
    selectStrategies() {
      this.strategies.forEach((el) => {
        el.selected = false;
      });
      this.strategyCombobox.forEach((str) => {
        this.strategies.forEach((el) => {
          if (str.id == el.id) str.selected = true;
        });
      });
    },
    handleChange(values) {
      this.range.start = moment(values[0]._d).format("YYYY-MM-DD");
      this.range.end = moment(values[1]._d).format("YYYY-MM-DD");
      this.getDataApi();
    },
    generateReport() {
      let ids = [];
      let firing_ids = [];
      let type = null;
      this.selected.forEach((item) => ids.push(item.id));
      if (ids.length > 1) {
        type = "MANY_FIRING";
        firing_ids = ids;
      } else {
        type = "FIRING";
        firing_ids = [ids[0]];
      }

      reportingService
        .generateReport(type, firing_ids)
        .then((resp) => {
          this.$store.commit("showSnackbar", "Relatório gerado com sucesso.");
        })
        .catch((err) => {
          console.error(err);
          this.$store.commit("showSnackbar", "Houve um erro ao gerar o relatório.");
        });
    },
    openDetailModal(item) {
      this.$refs.notification.open(item);
    },
    getRange(startOffset = 0, endOffset = 0, period = "day") {
      return [
        moment().subtract(startOffset, period).startOf(period),
        moment().subtract(endOffset, period).endOf(period),
      ];
    },
    totalNotifications(firings) {
      let totalNotifications = 0;
      firings.forEach((firing) => {
        totalNotifications += firing.notifications;
      });
      return totalNotifications;
    },
    nameUser(item) {
      let strategy_snapshot = {};
      try {
        strategy_snapshot = JSON.parse(item.strategy_snapshot);
      } catch (e) {
        strategy_snapshot = item.strategy_snapshot;
      }
      return (strategy_snapshot && strategy_snapshot.last_notification_user)
        ? strategy_snapshot.last_notification_user.split(" ")[0] + ","
        : "";
    },
    setColor2(value, good, bad, isText = false) {
      let color = isText ? "" : "grey lighten-2";
      if (good != null && value != null) {
        if (value >= good) {
          color = "green";
        } else {
          color = "amber";
        }
        if (bad != null && color != "green") {
          if (value >= bad) {
            color = "amber";
          } else {
            color = "red";
          }
        }
      }
      return isText ? color + "--text" : color;
    },
    setColor3(value, good, bad, isText = false) {
      let color = isText ? "" : "grey lighten-2";
      if (good != null && value != null) {
        if (value <= good) {
          color = "green";
        } else {
          color = "amber";
        }
        if (bad != null && color != "green") {
          if (value >= bad) {
            color = "red";
          } else {
            color = "amber";
          }
        }
      }
      if (value == 0) return isText ? "" : "grey lighten-2";
      return isText ? color + "--text" : color;
    },
    setColor(index, row, text = false, line = -1) {
      let color = text ? "" : "grey lighten-2",
        notifications = 0,
        total = 0,
        resultado = 0;
      text = text ? "--text" : "";

      if (line > -1) {
        resultado = line * 100;
      } else {
        row.firings.forEach((item) => {
          notifications += item.notifications;
          total += item[index];
        });
        resultado = (total * 100) / notifications;
      }

      if (row["indicator_good_" + index.replace("proposals_", "")] != null) {
        if (resultado >= row["indicator_good_" + index.replace("proposals_", "")]) {
          color = "green";
        } else {
          color = "amber";
        }
      }
      if (
        row["indicator_bad_" + index.replace("proposals_", "")] != null &&
        color != "green"
      ) {
        if (resultado >= row["indicator_bad_" + index.replace("proposals_", "")]) {
          color = "amber";
        } else {
          color = "red";
        }
      }

      return color + text;
    },
    calcTotal(row, index) {
      switch (index) {
        case "notifications":
          return row.notifications;
        case "accessed":
          return row.accessed;
        case "proposals_confirmed":
          return row.proposals_confirmed;
        case "proposals_agreed":
          return row.proposals_agreed;
        case "localized":
          return row.localized;
      }
    },
    calcPercent(firings, total) {
      let notifications = 0;
      firings.forEach((firing) => {
        notifications += firing.notifications;
      });
      return notifications ? ((total * 100) / notifications).toFixed(3) : 0;
    },
    checkNotificationToday(date) {
      if (!date) return false;
      let value = date.includes("Z") ? new Date(date) : new Date(date + "Z");
      let _diff = moment().isSame(moment.utc(value).local(), "day");
      return _diff;
    },
    calcDiffDate() {
      let d = new Date();
      let date1 = Cookies.get("dateStrategies");
      let date2 = d.getTime();

      if (!date1) return true;

      // var date1 = new Date(dtPartida.slice(0,4), dtPartida.slice(4,6),dtPartida.slice(6,8), dtPartida.slice(9,11), dtPartida.slice(12,14)),
      //     date2 = new Date(dtChegada.slice(0,4), dtChegada.slice(4,6),dtChegada.slice(6,8), dtChegada.slice(9,11), dtChegada.slice(12,14));

      let diffMs = date2 - date1;
      let diffHrs = Math.floor((diffMs % 86400000) / 3600000);
      // let diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
      // let diff = diffHrs + 'h ' + diffMins + 'm';
      return diffHrs ? true : false;
    },
    goToStrategy(strategy) {
      let vm = this;
      let name = strategy.active ? "Sob demanda" : "Planejamento";
      this.$router.push({
        name,
        query: {
          strategy_id: strategy.id,
        },
      });
    },
    goToApproach(strategy) {
      this.$router.push({
        name: "Abordagem",
        params: {
          edit: true,
          approach_id: strategy.approach_id,
        },
      });
    },
  },
  // beforeDestroy() {
  //     clearInterval(this.interval);
  // },
};
</script>

<style>
tr {
  cursor: default;
}

.tr-shadow {
  background-color: rgba(0, 0, 0, 0.06);
}

.hot {
  background-color: #f47d76 !important;
  border-color: #f47d76 !important;
}

.received {
  background-color: #d3ffce !important;
  border-color: #d3ffce !important;
}

.span-range {
  display: inline-block;
  width: 45%;
  font-size: small;
}

.good-accurancy {
  font-size: 12px;
  color: #049804;
  font-weight: 400;
}

.v-date-picker-table {
  height: auto !important;
}

.v-date-range .v-menu--inline {
  display: inline;
}

.hot .v-chip__content {
  padding: 4px 5px !important;
  background-color: #f47d76 !important;
  border-color: #f47d76 !important;
}

.received .v-chip__content {
  background-color: #d3ffce !important;
  border-color: #d3ffce !important;
  padding: 0px 9px !important;
}

.text-details-none.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}

table.v-table tbody td.v-datatable__expand-col,
table.v-table tbody .v-datatable__progress th {
  height: 0 !important;
}
.theme--light.v-datatable .v-datatable__expand-col--expanded {
  /* padding: 0 !important; */
}
/* .v-datatable__expand-row {
    background-color: #f5f5f5 !important;
}
.notHoverHead {
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.12);
}
.notHoverHead
    .theme--light.v-table
    thead
    tr:hover:not(.v-datatable__expand-row) {
    background: #fff;
}
.notHoverHead .v-datatable__actions__range-controls {
    margin-right: 0;
} */

.list-no-pl .v-list__tile.theme--light {
  padding-left: 0;
}
</style>
